import {AnyHash, FieldConfig, FieldDataTypes, nNumber, nString, uNumber, uString} from "@hidat/huijs-common";
import {LocalDate} from "@js-joda/core";
import {HasTenantResource, ResourceConfig} from "@hidat/huijs-resource";
import {RblFieldConfigs, RblResourceInterface} from "../rbl-resource.interface";

const metaExtended = 'metaExtended';

export const ChangeSetItemConfig = new ResourceConfig('ChangeSetItem', 'change_set_items', true, true)
  .addFields([
    RblFieldConfigs.changeSet,
    RblFieldConfigs.list,
    RblFieldConfigs.listItem,
    RblFieldConfigs.library,
    RblFieldConfigs.libraryItem,
    RblFieldConfigs.libraryTitle,

    new FieldConfig('changeType'),
    new FieldConfig('rotationStatus', FieldDataTypes.NUMBER, true, 'TARGET_ROTATION_STATUS'),
    new FieldConfig('startDate', FieldDataTypes.DATE),
    new FieldConfig('effectiveDate', FieldDataTypes.DATE).setEditable(false),
    new FieldConfig('category'),
    new FieldConfig('notes'),
    new FieldConfig(metaExtended, FieldDataTypes.HASH).setEditable(false),
    new FieldConfig('prevMeta', FieldDataTypes.HASH).setEditable(false),

    new FieldConfig('secondaryCategory').setEditPath(metaExtended),
    new FieldConfig('artistKeyword').setEditPath(metaExtended),
    new FieldConfig('nameKeyword').setEditPath(metaExtended)

  ])
  .setSorts({
    name: 'name'
  })
  .setDefaultSort('name')


export interface ChangeSetItemMetaInterface {
  secondaryCategory?: uString;
  artistKeyword?: uString;
  nameKeyword?: uString;
}

export interface ChangeSetItemPreviousMetaInterface {
  category?: uString;
  secondaryCategory?: uString;
  artistKeyword?: uString;
  nameKeyword?: uString;
}

export interface ChangeSetItemInterface extends RblResourceInterface<number>, HasTenantResource {
  changeSetId: uNumber;
  listId: uNumber;
  listItemId: uNumber;
  libraryId: uNumber;
  libraryItemId: uNumber;
  libraryTitleId: uNumber;

  changeType: uString;
  rotationStatus: nNumber;
  category: nString;
  notes: nString;
  startDate: LocalDate | undefined | null;
  effectiveDate: LocalDate | undefined | null;
  metaExtended: AnyHash | undefined;
  prevMeta: AnyHash | undefined;
}
